module.exports = __webpack_public_path__ + "img/user_dashboard.6d3595a2.jpg";